
export const checkMicrophonePermission = async () => {
    try {
        if (!navigator.permissions) {
            throw new Error("Permissions API not supported");
        }
        const result = await navigator.permissions.query({ name: "microphone" });

        if (result.state === "prompt") {
            return requestMicrophonePermission();
        } else {
            return result.state;
        }
    } catch (err) {
        console.log(err);
        return;
    }
};

export const requestMicrophonePermission = async () => {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        return "granted";
    } catch (err) {
        console.log(err.message);
        return "denied";
    }
};